import { SimpleTextTooltip } from "components/ui/Tooltip";
import classNames from "components/ui/classNames";
import { BadgeCheckIcon } from "lucide-react";

interface InPortfolioTagProps {
  className?: string;
}
export default function InPortfolioTag({ className }: InPortfolioTagProps) {
  return (
    <SimpleTextTooltip content="Na Sua Carteira">
      <div
        className={classNames(
          "inline-flex items-center justify-center space-x-2 rounded-md bg-brand/5 p-1 px-2 text-brand",
          className,
        )}
      >
        <BadgeCheckIcon className="h-5 w-5" />
      </div>
    </SimpleTextTooltip>
  );
}
